import { BadgeCheck, CircleAlert } from 'lucide-react';

export function VerificationBadge({ status }: { status: 'VERIFIED' | 'UNVERIFIED' }) {
  const verified = status === 'VERIFIED';
  const label = verified ? 'Retailer link verified' : 'Retailer link not yet verified';
  const Icon = verified ? BadgeCheck : CircleAlert;
  return (
    <span
      className={'link-verification ' + status.toLowerCase()}
      title={label}
      aria-label={label}
    >
      <Icon size={15} strokeWidth={2.4} aria-hidden="true" />
      {label}
    </span>
  );
}

export function OfficialStoreBadge() {
  return (
    <span className="link-verification verified" title="Official store" aria-label="Official store">
      <BadgeCheck size={15} strokeWidth={2.4} aria-hidden="true" />
      Official store
    </span>
  );
}
